import { Chart } from 'chart.js';
import Labels from './labels';
import { createValueLabelsPlugin } from './valueLabelsPlugin';

const getAmountInvoicesByPeriod = (ctxId, state, invoices) => {
    const ctx = document.getElementById(ctxId);

    if (!ctx) {
        return
    }

    if (state.chartInvoicesAmount) {
        state.chartInvoicesAmount.destroy();
    }

    const labels = {
    daily: Labels(state.shiftPeriod).daily,
    monthly: Labels(state.shiftPeriod).monthly,
    quarterly: Labels(state.shiftPeriod).quarterly,
    yearly: Labels(state.shiftPeriod).yearly
    };

    const data = getData(invoices, state)

    const chart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: labels[state.period],
            datasets: [
                {
                    label: 'Transferencia',
                    data: data[state.period].transfer,
                    backgroundColor: '#A8E6A3',
                    borderColor: '#A8E6A3',
                    borderWidth: 1
                },
                {
                    label: 'Tarjeta',
                    data: data[state.period].card,
                    backgroundColor: '#90CAF9',
                    borderColor: '#90CAF9',
                    borderWidth: 1
                }
            ]
        },
        options: {
            scales: {
                xAxes: [{ stacked: true }],
                yAxes: [{ stacked: true, ticks: { beginAtZero: true } }]
            },
            tooltips: {
                enabled: false
            },
        },
        plugins: [createValueLabelsPlugin({
        format: (v) => `${Number(v).toFixed(2)} €`
        })]
    });

    return chart;
}

const getData = (invoices, state) => {
  const dataDayTransfer = {};
  const dataDayCard = {};
  Labels(state.shiftPeriod).dailyIds.forEach(id => {
    dataDayTransfer[id] = 0;
    dataDayCard[id] = 0;
  });

  invoices.forEach(inv => {
    const date = new Date(inv.invoiceDate);
    const key = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    if (dataDayTransfer[key] === undefined) return;

    const pm = Number(inv.paymentMode);
    if (pm === 2) dataDayTransfer[key] += inv.totalPrice || 0; // transferencia
    if (pm === 1) dataDayCard[key] += inv.totalPrice || 0;     // tarjeta
  });

  const dataMonthTransfer = {};
  const dataMonthCard = {};
  Labels(state.shiftPeriod).monthlyIds.forEach(id => {
    dataMonthTransfer[id] = 0;
    dataMonthCard[id] = 0;
  });

  invoices.forEach(inv => {
    const date = new Date(inv.invoiceDate);
    const key = `${date.getMonth() + 1}-${date.getFullYear()}`;
    if (dataMonthTransfer[key] === undefined) return;

    const pm = Number(inv.paymentMode);
        if (pm === 2) dataMonthTransfer[key] += inv.totalPrice || 0; // transferencia
        if (pm === 1) dataMonthCard[key] += inv.totalPrice || 0;     // tarjeta
    });

    const dataQuarterTransfer = {};
    const dataQuarterCard = {};
    Labels(state.shiftPeriod).quarterlyIds.forEach(id => {
    dataQuarterTransfer[id] = 0;
    dataQuarterCard[id] = 0;
    });

    const dataYearTransfer = {};
    const dataYearCard = {};
    Labels(state.shiftPeriod).yearlyIds.forEach(id => {
    dataYearTransfer[id] = 0;
    dataYearCard[id] = 0;
    });

    invoices.forEach(inv => {
    const date = new Date(inv.invoiceDate);
    const q = Math.floor(date.getMonth() / 3) + 1;
    const qKey = `Q${q}-${date.getFullYear()}`;
    const yKey = String(date.getFullYear());

    const pm = Number(inv.paymentMode);

    if (dataQuarterTransfer[qKey] !== undefined) {
        if (pm === 2) dataQuarterTransfer[qKey] += inv.totalPrice || 0;
        if (pm === 1) dataQuarterCard[qKey] += inv.totalPrice || 0;
    }

    if (dataYearTransfer[yKey] !== undefined) {
        if (pm === 2) dataYearTransfer[yKey] += inv.totalPrice || 0;
        if (pm === 1) dataYearCard[yKey] += inv.totalPrice || 0;
    }
    });

  return {
    daily: { transfer: Object.values(dataDayTransfer), card: Object.values(dataDayCard) },
    monthly: { transfer: Object.values(dataMonthTransfer), card: Object.values(dataMonthCard) },
    quarterly: { transfer: Object.values(dataQuarterTransfer), card: Object.values(dataQuarterCard) },
    yearly: { transfer: Object.values(dataYearTransfer), card: Object.values(dataYearCard) },
    };
};

export default getAmountInvoicesByPeriod;